export function getRandomText(len: number) {
  return Math.random().toString(36).substr(2, len);
}
